import { common_getProps } from '../../../components/common_getProps'
import Section, { getStaticPathsByLocale } from '../Google-Search'

export async function getStaticProps(context) {
    return common_getProps(context)
}

export async function getStaticPaths() {
    return getStaticPathsByLocale('es')
}

export default Section
